import { DropResult } from 'react-beautiful-dnd'
import { PDFTitle } from './SocialForm.constants'

const MAX_DESCRIPTION_LENGTH = 40

export const getWebsiteDescription = (value?: string): string => {
  let domain = value ?? ''
  if (value && value?.length > MAX_DESCRIPTION_LENGTH) {
    const url = new URL(value)
    domain = url.hostname ?? ''
  }
  return domain
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const processDropResult = (event: DropResult, toSort: any[]): any[] => {
  const copy = [...toSort]
  const source = event?.source?.index ?? -1
  const destination = event?.destination?.index ?? -1
  if (source > -1 && destination > -1) {
    copy.splice(source, 1)
    copy.splice(destination, 0, toSort[source])
  }
  return copy
}

export const getPDFTitleVariation = (variant: string): string => {
  switch (variant) {
    case 'college':
      return PDFTitle.COLLEGE
    default:
      return PDFTitle.DEFAULT
  }
}
